'use client'

import { useEffect } from 'react'
import Script from 'next/script'

export default function Home() {
  useEffect(() => {
    // Register service worker for PWA
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(err => {
        console.log('SW registration failed:', err)
      })
    }
  }, [])

  return (
    <>
      <div id="root"></div>
      <Script src="/client/app.js" type="module" strategy="afterInteractive" />
    </>
  )
}
